import React from "react";
import "./arrowButton.scss";

const ArrowButton = (props: ArrowButtonInterface) => {
  const { text, way, onAction, gtmMark } = props;

  return (
    <>
      {way === "right" ? (
        <div className="a-arrowButton right" onClick={() => onAction()}>
          <label>{text}</label>
          <button className={`${gtmMark}`}>
            <span className={`icon-chevron-right1  ${gtmMark}`} />
          </button>
        </div>
      ) : (
        <div className="a-arrowButton left" onClick={() => onAction()}>
          <button className={`${gtmMark}`}>
            <span className={`icon-chevron-left1  ${gtmMark}`} />
          </button>
          <label>{text}</label>
        </div>
      )}
    </>
  );
};

interface ArrowButtonInterface {
  text: string;
  onAction?: any;
  way: "right" | "left";
  gtmMark?: string;
}

export default ArrowButton;
